@let shouldShowTitle = title() && showTitle() === true;

@if (activeNavSection(); as section) {
  <div class="sidebar-nav-wrapper" [ngClass]="{ 'sidebar-nav-wrapper--b': bottomSpacing() }" data-elastic-exclude>
    <div class="sidebar-nav df-laptop-down flex--column fill">
      @if (shouldShowTitle) {
        <div class="section-title inline-block relative pr-medium-x pr-large-y z1 white-bg surface-primary">
          <h1 class="font-heading-1 nordic-blue-900-text text-icon-primary font-headline-medium">{{ title() }}</h1>
        </div>
      }

      <nav [attr.aria-label]="activeNavItem()?.teaserTitle">
        @if (section.items?.length) {
          <ul
            [attr.data-testid]="dataTestId() + '-desktop'"
            class="sidebar-nav-items no-list-style ps-large-bottom nordic-blue-900-text text-icon-primary section-desktop-body dn-laptop-down"
            [ngClass]="{
              'mr-xsmall-t': !shouldShowTitle && topSpacing(),
            }"
          >
            <ng-container
              [ngTemplateOutlet]="listContent"
              [ngTemplateOutletContext]="{ content: section, emitClick: allowCustomFunction() }"
            ></ng-container>
          </ul>
        }

        <fcom-expand
          class="relative block fill section-accordion-body dn-laptop-up"
          [attr.data-testid]="dataTestId() + '-mobile'"
          [ngClass]="mobileExpandClasses()"
          [open]="expanded()"
          [ariaId]="contentId"
          [ariaLabelledBy]="triggerId"
          [class.dn-laptop-down]="(section.items?.length ?? 0) < 1"
        >
          <button
            ngProjectAs="trigger"
            data-testid="sidebar-nav-expand-trigger"
            [id]="triggerId"
            [attr.aria-controls]="contentId"
            [attr.aria-expanded]="expanded()"
            [finElemTracker]="'navigation-open: ' + section.link"
            [finElemContext]="TRACKING_CONTEXT"
            [finElemType]="ElementTypes.LINK"
            class="trigger flex flex--center pr-xsmall-y fill dn-laptop-up"
            [class.border-bottom]="expanded()"
            [class.dn]="(section.items?.length ?? 0) < 1"
            (click)="toggleExpand($event)"
          >
            <div class="flex-1 ps-large-l">
              <div
                class="flex flex--start nordic-blue-900-text text-icon-primary transform-none font-body-1 font-body-medium-bold"
              >
                {{
                  nested() ? activeNavItem()?.linkText || activeNavItem()?.teaserTitle : activeNavItem()?.teaserTitle
                }}
              </div>
            </div>
            <div class="ps-large-r">
              <fcom-icon
                class="flex-1 flex--nogrow rotate nordic-blue-900-text text-icon-primary inline-block icon-medium"
                [class.rotate-active]="expanded()"
                [name]="SvgLibraryIcon.CHEVRON_DOWN"
              />
            </div>
          </button>
          <div class="content">
            <ul
              class="section-navi-items no-list-style ps-large nordic-blue-900-text text-icon-primary white-bg surface-primary"
            >
              <ng-container
                [ngTemplateOutlet]="listContent"
                [ngTemplateOutletContext]="{ content: section, emitClick: true }"
              ></ng-container>
            </ul>
          </div>
        </fcom-expand>
      </nav>
    </div>
  </div>
} @else if (activeNavSection() === undefined) {
  <div class="sidebar-nav fill ms-medium-b" data-elastic-exclude>
    @if (shouldShowTitle) {
      <div class="section-title inline-block relative ps-large-x ps-large-y z1 white-bg surface-primary">
        <h1 class="font-heading-1 nordic-blue-900-text text-icon-primary font-headline-medium">
          {{ title() }}
        </h1>
      </div>
    }
  </div>
}

<ng-template #listContent let-content="content" let-emitClick="emitClick">
  @if (content.link) {
    <ng-container
      [ngTemplateOutlet]="listItem"
      [ngTemplateOutletContext]="{
        content: content,
        title: nested() ? content.linkText || content.teaserTitle : content.teaserTitle,
        styleClasses: 'nordic-blue-900-text text-icon-primary',
        onLinkClicked: emitClick ? content : null,
      }"
    ></ng-container>
  }
  @for (item of content.items; track $index) {
    @if (item.link && !item.hideInSectionNavi) {
      <ng-container
        [ngTemplateOutlet]="listItem"
        [ngTemplateOutletContext]="{
          content: item,
          title: item.teaserTitle,
          styleClasses: nested()
            ? 'nordic-blue-900-text text-icon-primary ms-small-l'
            : 'nordic-blue-900-text text-icon-primary',
          onLinkClicked: emitClick ? item : null,
        }"
      ></ng-container>
    }
  }
</ng-template>

<ng-template
  #listItem
  let-content="content"
  let-title="title"
  let-styleClasses="styleClasses"
  let-onLinkClicked="onLinkClicked"
>
  <li
    [ngClass]="{
      'ms-small-b': theme() === SidebarNavTheme.HOVER_BG && !nested(),
      'ms-large-b': isNewBrand() && theme() !== SidebarNavTheme.HOVER_BG,
    }"
  >
    <fcom-sidebar-item
      [attr.data-testid]="content.testid ?? null"
      [link]="content.link"
      [title]="title"
      [external]="content.external ?? false"
      [openInNewTab]="content.openInNewTab ?? false"
      [active]="content.active ?? false"
      [loginRequired]="content.loginRequired ?? false"
      [styleClasses]="styleClasses"
      [tracking]="tracking()"
      [trackingLabel]="trackingLabel()"
      [hoveredBG]="theme() === SidebarNavTheme.HOVER_BG"
      (linkClicked)="onLinkClicked && itemClicked.emit({ item: onLinkClicked, event: $event })"
    ></fcom-sidebar-item>
  </li>
</ng-template>
